export default "__VITE_ASSET__DXe2fyij__"